import { DefaultError, useMutation } from "@tanstack/react-query";
import { updateFaqGroup } from "../api/updateFaqGroup";
import { invalidateFaqGroupsQuery } from "../queries/useFaqGroupsQuery";
import { FaqGroupToUpdate } from "../types";

type Params = {
  faqGroupData: FaqGroupToUpdate;
  faqGroupId: string;
};

export const useUpdateFaqGroupMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await updateFaqGroup(params);
    },
    onSuccess: () => {
      invalidateFaqGroupsQuery();
    },
    onError: (e) => {
      console.error("Error occurred when updating faq group", e);
    },
  });
};
